import formatDate from '@/module/util/format-date'
import formatTime from '@/module/util/format-time'

export default {
    props: {
        water: {
            type: Array,
            required: true
        }
    },

    methods: {
        formatDate,
        formatTime
    }
}
